type NotificationMetadata = Record<string, unknown> | null;

function metadataString(metadata: NotificationMetadata, key: string): string | null {
  const value = metadata?.[key];
  return typeof value === 'string' && value.length > 0 ? value : null;
}

/**
 * Maps a persisted notification to a stable in-app destination.
 * Keeping this pure makes notification deep-links consistent across the
 * popover, realtime events and future push handlers.
 */
export function getNotificationDestination(
  type: string,
  metadata: NotificationMetadata,
): string | null {
  if (type === 'MENTION') {
    const channelId = metadataString(metadata, 'channelId');
    return channelId ? `/channel/${channelId}` : null;
  }

  if (type === 'DM') {
    const senderId = metadataString(metadata, 'senderId');
    return senderId ? `/dm/${senderId}` : null;
  }

  if (type === 'CHANNEL_INVITE') {
    const channelId = metadataString(metadata, 'channelId');
    return channelId ? `/channel/${channelId}` : null;
  }

  if (type === 'FRIEND_REQUEST') {
    return '/friends/requests';
  }

  if (type === 'FRIEND_ACCEPTED') {
    const userId = metadataString(metadata, 'userId');
    return userId ? `/dm/${userId}` : '/friends/requests?tab=outgoing';
  }

  return null;
}
